'use client';

import Image from 'next/image';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { SxProps, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import FooterDictionary from '@/types/dictionaries/Footer';
import { FOOTER } from '@/constants/footer';
import PartnerLogos from '@/components/Footer/components/PartnerLogos';

interface FooterProps {
	dict: FooterDictionary;
	footerConstants: (typeof FOOTER)[keyof typeof FOOTER];
}

const styles = {
	divider: {
		border: '2px solid',
		borderColor: 'red.main',
		height: '2px',
	},
	wrapper: {
		py: '24px',
	},
	container: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: '32px',
	},
	partnerLogos: {
		borderBottom: '1px solid',
		borderColor: 'grey.light',
		pt: { xs: '12px', md: '0px' },
		pb: { xs: '28px', md: '30px' },
		mb: { xs: '12px', md: '24px' },
	},
} as const satisfies Record<string, SxProps>;

export default function Footer({ dict, footerConstants }: Readonly<FooterProps>) {
	const theme = useTheme();
	const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));
	const year = new Date().getFullYear();
	const partnerLogos = footerConstants.partnerLogos;

	return (
		<>
			<Divider sx={{ ...styles.divider }} />
			<Box component="footer" bgcolor="grey.ultraDark" color="white.main" sx={{ ...styles.wrapper }}>
				{partnerLogos.length > 0 && (
					<Container maxWidth="xl">
						<Box sx={styles.partnerLogos}>
							<PartnerLogos partnerLogoData={partnerLogos} />
						</Box>
					</Container>
				)}
				<Container maxWidth="xl" sx={{ ...styles.container }}>
					<Image
						width={isMobileOrTablet ? 147 : 184}
						height={isMobileOrTablet ? 32 : 40}
						src="/logo_IR_white.svg"
						alt="IR logo"
					/>
					<Typography variant="h7">
						©{year}. {dict.ingersollTrademark}
					</Typography>
				</Container>
			</Box>
		</>
	);
}
